import React, { FC } from 'react';
import { DecisionHeaderSubtitle } from '../../../../decision/header/DecisionHeaderSubtitle';
import { DecisionHeaderTitle } from '../../../../decision/header/DecisionHeaderTitle';
import { SearchDecision } from '../../../../decision/decision.types';
import { addNewPositionToUrl } from '../../../../decision/decisionUtils';

type Props = {
  index?: number;
  decision: SearchDecision;
  source: string;
};

export const DecisionSearchHeader: FC<Props> = ({
  decision,
  index = 0,
  source,
}) => {
  const onDecisionTitleClicked = () => {
    const position = typeof index !== 'undefined' ? index : 0;
    addNewPositionToUrl(position);
  };

  return (
    <>
      <DecisionHeaderTitle
        decision={decision}
        index={index}
        source={source}
        onDecisionTitleClicked={onDecisionTitleClicked}
      />
      <DecisionHeaderSubtitle
        arretDecAtt={decision.arretDecAtt}
        solution={decision.solution}
        validation={decision.validation}
        docId={decision.docId}
        automaticMetadata={decision.automaticMetadata}
        source={source}
      />
    </>
  );
};
